import { styled, CardActions } from '@mui/material';

export const StyledCardHeader = styled('div')`
    padding: 1.5rem;
`;

export const StyledCardContent = styled('div')`
    padding: 0 1.5rem 1rem 1.5rem;
`;

export const StyledCardActions = styled(CardActions)`
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem;
`;
